import { t } from "i18next";
import { PlanName } from "@/common/enums/enums";

// The plan name comes from billing in English ("Free Trial") and is also
// compared as a value; only the free trial has a translated label. Paid plan
// names are product names and are shown as billing sends them.
export const planDisplayName = (
  planName: string | null | undefined,
): string | null => {
  const name = planName?.trim();
  if (!name) return null;
  return name === PlanName.FREE_TRIAL.toString()
    ? t("plan.freeTrial", { defaultValue: name })
    : name;
};
